import { connect } from 'react-redux'

import RichCheckoutHeader from '../../components/richCheckout/Header'

import { getSubtotal, getTax, getTotal, getCartQuantity2 } from '../../selectors/cart'

const mapStateToProps = (state, ownProps) => {
  const cartQuantity = getCartQuantity2(state)
  const subtotal = getSubtotal(state)
  const tax = getTax(state)
  const total = getTotal(state)

  const { orderNumber } = ownProps

  return { cartQuantity, orderNumber, subtotal, tax, total }
}

export default connect(mapStateToProps, undefined)(RichCheckoutHeader)
